/**
 * backToTop
 * =========
 * Check window height and pixels scrolled - if combined value  > footerHeight then calc the diff &
 * apply this value to the button's bottom positioning so it stops & sticks above the footer even if
 * the user scrolls to the bottom of page.
 */
export const backToTop = () => {
  if (window.scrollY >= 700) {
    document.body.classList.add('back-to-top');
  } else {
    document.body.classList.remove('back-to-top');
  }
};

/**
 * shiftTabFocusToTop
 * ==================
 * Check window height and pixels scrolled - if combined value  > footerHeight then calc the diff &
 * apply this value to the button's bottom positioning so it stops & sticks above the footer even if
 * the user scrolls to the bottom of page.
 */
export const shiftTabFocusToTop = () => {
  document.getElementById('back-to-top')?.addEventListener('click', () => {
    document.getElementsByClassName('header__brand')[0]?.focus();
  });
};

/**
 * topButtonStickAboveFooter
 * =========================
 * Check window height and pixels scrolled - if combined value  > footerHeight then calc the diff &
 * apply this value to the button's bottom positioning so it stops & sticks above the footer even if
 * the user scrolls to the bottom of page.
 */
export const topButtonStickAboveFooter = () => {
  const heightAndPixelsScrolled = window.innerHeight + window.scrollY;
  const footerHeight = document.getElementById('footer').offsetTop;
  const el = document.getElementById('back-to-top');
  const offsetValue = heightAndPixelsScrolled - footerHeight;

  if (!el) return;

  if (heightAndPixelsScrolled > footerHeight) {
    el.style.bottom = `calc(2rem + ${offsetValue}px)`;
    el.style.transition = 'none';
  } else {
    el.style.bottom = '2rem';
    el.style.transition = 'all 300ms ease-in-out, background 200ms ease-in-out';
  }
};

/**
 * initBackToTop
 * =============
 */
export const initBackToTop = () => {
  window.addEventListener('scroll', () => {
    backToTop();
    topButtonStickAboveFooter();
  });
};
